<div class="w-100" style="padding: 20px; overflow:auto; max-height:90vh;">
	<div class="w-100 jmPageTitle" style="text-align:center">
		Journeys Map Global Account
	</div>

	<div style="padding:15px;">
		<span *ngIf="completeType==='signup'">You have successfully created your Journeys Map Global Account.  You will be able to switch between accounts from your Profile menu and within the <b>Switch Accounts</b> section.  Happy Exploring!"</span>
		<span *ngIf="completeType==='login'">You have successfully linked to your Journeys Map Global Account.  You will be able to switch between accounts from your Profile menu and within the <b>Switch Accounts</b> section.  Happy Exploring!"</span>
	</div>
	<div  style="padding:15px;" class="text-center">
		<button id="btnClose" type="button" class="btn btn-primary" (click)="close()">Close</button>
	</div>
</div>
